import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import axios from 'axios';

// Custom language detector based on IP geolocation
const ipLanguageDetector = {
  name: 'ipLanguageDetector',
  
  lookup(options) {
    try {
      // Try to get cached language first
      const cachedLang = localStorage.getItem('i18nextLng');
      if (cachedLang && (cachedLang === 'en' || cachedLang === 'id')) {
        return cachedLang;
      }

      // Check browser language
      const browserLang = navigator.language || navigator.userLanguage;
      if (browserLang) {
        const lang = browserLang.toLowerCase();
        if (lang.startsWith('id')) {
          localStorage.setItem('i18nextLng', 'id');
          return 'id';
        }
      }

      // Default to Indonesian for first-time visitors
      localStorage.setItem('i18nextLng', 'id');
      
      // Start async IP detection in background
      this.detectAsync();
      
      // Return Indonesian as default
      return 'id';
    } catch (error) {
      console.error('Error in language detector:', error);
      return 'id'; // Default to Indonesian on error
    }
  },

  async detectAsync() {
    try {
      const response = await axios.get('https://ipapi.co/json/', { timeout: 3000 });
      const countryCode = response.data.country_code;
      
      // Only change if no cached language exists
      const cachedLang = localStorage.getItem('i18nextLng');
      if (!cachedLang) {
        const detectedLang = countryCode === 'ID' ? 'id' : 'en';
        localStorage.setItem('i18nextLng', detectedLang);
        
        if (i18n.language !== detectedLang) {
          i18n.changeLanguage(detectedLang);
        }
      }
    } catch (error) {
      // Silently fail - user already has Indonesian as default
      console.log('IP detection unavailable, using default language');
    }
  },

  cacheUserLanguage(lng) {
    if (lng && typeof lng === 'string' && (lng === 'en' || lng === 'id')) {
      localStorage.setItem('i18nextLng', lng);
    }
  }
};

// Initialize language detector with custom IP detector
const languageDetector = new LanguageDetector();
languageDetector.addDetector(ipLanguageDetector);

i18n
  .use(Backend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'id', // Fallback ke Indonesian
    supportedLngs: ['en', 'id'],
    lng: 'id', // Default language Indonesian
    
    detection: {
      order: ['localStorage', 'ipLanguageDetector', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false, // Disable suspense to avoid loading issues
    },

    // Add load option to prevent errors
    load: 'languageOnly',
    cleanCode: true,
  });

export default i18n;
